import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrerenderDetectorService {

  constructor() {}

  public isPrerendering(): boolean {
    // this only works for Chrome and Edge (Chromium) browsers
    let isPrerendering: boolean|undefined = (document as (typeof document & {prerendering?: boolean}))?.prerendering;
    return (isPrerendering ?? false)
  }
}